var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"8rem","cursor":"pointer"},on:{"click":_vm.moveToSure}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/home/promo-banner.gif"),"alt":"promo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }